export const AVATAR_COLORS = [
    { bg: '#FEE4E2', text: '#B42318' },
    { bg: '#FEF0C7', text: '#B54708' },
    { bg: '#D1FADF', text: '#067647' },
    { bg: '#E0EAFF', text: '#3538CD' },
    { bg: '#F4EBFF', text: '#6941C6' },
    { bg: '#E0F2FE', text: '#0369A1' },
    { bg: '#FFE4E6', text: '#BE123C' },
    { bg: '#FDF4FF', text: '#6F2DA8' },
    { bg: '#ECFDF5', text: '#054F31' },
];
export const NETWORK_CHIP_COLORS = [
    { bg: '#E3F2FD', text: '#1976D2' }, // blue
    { bg: '#F3E5F5', text: '#7B1FA2' }, // purple
    { bg: '#FEF3C7', text: '#92400E' }, // amber
    { bg: '#DCFCE7', text: '#166534' }, // green
];
export const TYPE_LABEL_MAP = {
    // paid_media: 'Paid Media',
    // affiliate: 'Affiliate',
    // aeo: 'AEO',
    "paid_media": 'Paid Media',
    "affiliate": 'Affiliate',
    "aeo": 'AEO',
    'paid media': 'Paid Media',
    'Paid Media': 'Paid Media',
    'Affiliate': 'Affiliate',
    'AEO': 'AEO',
};
export function getInitials(name = '') {
    return name
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
}
export function getAvatarColor(index) {
    return AVATAR_COLORS[index % AVATAR_COLORS.length];
}
